<template>
  <div class="container">
    <div class="library-banner" :class="backgroundClass">
      <div class="flex-container justify-space-between align-items-center">
        <div class="flex-item grow title-container">
          <ul class="breadcrumb" v-if="breadcrumbs">
            <li><a :href="libraryAllFoldersBeta">Library: All Folders</a></li>
            <slot name="breadcrumbList" />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toolkitUrls } from '@/links'
export default {
  name: 'LibraryRedesignBanner',
  data() {
    return { ...toolkitUrls }
  },
  props: {
    breadcrumbs: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: 'gray'
    }
  },
  computed: {
    backgroundClass () {
      return `bg-${this.backgroundColor}`
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/variables.less';
.library-banner.bg-gray {
  background: @background-light-gray;
}
.library-banner.bg-transparent {
  background: transparent;
}
.library-banner {
  margin-bottom: 2em;
  padding: 10px 16px;
  a {
    color: @gb_blue_medium;
  }
}
.breadcrumb {
  background: transparent;
  padding: 0px;
  margin-bottom: 0;
}
.header-folder {
  color: @gb_blue_medium;
}
</style>
